import { FeatureFlagContext } from 'Core/FeatureFlagContext'
import { useContext } from 'react'
/**
 *
 * @returns {{ viewMode: 'admin' | 'user', appView: 'admin' | 'user' }}
 */
const useAppView = () => {
  const context = useContext(FeatureFlagContext)
  const viewMode = context?.data?.viewMode || 'user'
  return { viewMode, appView: viewMode }
}

export default useAppView
